// Dependencies
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';

//  Components
import CartList from '../components/Cart/cartList';
import Checkout from '../components/Cart/checkout';
import Header from '../components/Header/header';
import CtaSingle from '../components/CTA/ctaSingle';
// Images
import PageBanner from '../components/Banner/page-banner';

class Carrito extends Component {
   constructor(props) {
      super(props);
      this.state = {
         comment: '',
      };
   }

   cleanCart() {
      this.props.dispatch({ type: 'CLEAN_CART' });
   }

   renderCarrito() {
      return (
         <div className="main-cart flex">
            <div className="column">
               <Header inicio={true}></Header>
               <PageBanner title="Carrito" />
               <div className="white-space-32"></div>
               <div className="carrito justify-center">
                  <div className="container">
                     <div className="column">
                        <div className="table-scroll">
                           <table
                              className="cart-table"
                              cellSpacing="0"
                              cellPadding="0"
                           >
                              <thead>
                                 <tr className="table-head">
                                    <th>Imagen</th>
                                    <th>Producto</th>
                                    <th>Unidad</th>
                                    <th>Cantidad</th>
                                    <th>Precio Unitario</th>
                                    <th>Total</th>
                                    <th></th>
                                 </tr>
                              </thead>
                              <CartList />
                           </table>
                        </div>
                        <div className="white-space-16"></div>
                        <div className="checkout-utils align-center row-responsive">
                           <div className="justify-end">
                              <button
                                 className="btn-link"
                                 onClick={this.cleanCart.bind(this)}
                              >
                                 Limpiar carrito
                              </button>
                           </div>
                        </div>
                        <div className="white-space-16"></div>
                        <div className="row-responsive">
                           <div className="column">
                              <h4 className="color-secondary">Comentarios</h4>
                              <div className="white-space-8"></div>
                              <textarea
                                 className="input-textarea"
                                 id="checkout-comment"
                                 onChange={event =>
                                    this.setState({
                                       comment: event.target.value,
                                    })
                                 }
                                 value={this.state.comment}
                                 maxLength="150"
                              />
                           </div>
                           <div className="total justify-end">
                              <table
                                 className="flex table-scroll table-subtotal auto"
                                 cellSpacing="0"
                                 cellPadding="0"
                              >
                                 <tbody>
                                    <tr>
                                       <td className="weight-medium">
                                          <h3 className="color-red">Total:</h3>
                                       </td>
                                       <td className="total">
                                          <h3 className="color-black">
                                             <NumberFormat
                                                decimalScale={2}
                                                displayType="text"
                                                fixedDecimalScale={true}
                                                prefix="$"
                                                value={this.props.subtotal}
                                                thousandSeparator={true}
                                             />
                                          </h3>
                                       </td>
                                    </tr>
                                 </tbody>
                              </table>
                           </div>
                        </div>
                        <div className="white-space-16"></div>
                        <Checkout
                           dispatch={this.props.dispatch}
                           cart={this.props.carrito}
                           direcciones={this.props.direcciones}
                           comment={this.state.comment}
                           onClearCart={this.cleanCart.bind(this)}
                        />
                        <div className="white-space-64"></div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      );
   }

   render() {
      return (
         <div className="inicio">
            <Helmet>
               <title>CARRITO - Expo Médica </title>
            </Helmet>
            {this.renderCarrito()}
            <CtaSingle></CtaSingle>
         </div>
      );
   }
}

function mapStateToProps(state) {
   return {
      auth: state.auth,
      carrito: state.carrito,
      direcciones: state.direcciones,
      subtotal: state.subtotal,
   };
}

export default withRouter(connect(mapStateToProps)(Carrito));



// WEBPACK FOOTER //
// ./src/pages/carrito.js